/* This example requires Tailwind CSS v2.0+ */
import { useState, useEffect } from 'react'
import { Disclosure } from '@headlessui/react'
import { LogoutIcon, MenuIcon, XIcon, FilterIcon, SearchIcon, UserIcon, CalendarIcon, GlobeAltIcon, LocationMarkerIcon, SortAscendingIcon } from '@heroicons/react/outline'
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import { logoutUser } from '../../reducers/users';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography'
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Slider from '@mui/material/Slider';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import { setGender, setLanguage, setMaxAge, setCity, setMinAge, setSortOption, setSearchQuery } from "../../reducers/filters"

const navigation = [
  { name: 'Home', href: '/home', current: true },
  { name: 'Admin', href: '/admin', current: false },
]

const genderList = [
  {
    value: 'Male',
    label: 'Male',
  },
  {
    value: 'Female',
    label: 'Female',
  },
  {
    value: 'All',
    label: 'All',
  }
];

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "85%",
  minWidth: 280,
  maxWidth: 500,
  bgcolor: 'background.paper',
  border: 'none',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  maxHeight: '90vh',
  overflowY: 'auto',
  m: 1
};


export function Navbar(props) {
  const { user, logoutUser, setGender, setLanguage, setMaxAge, setCity, setMinAge, setSortOption, setSearchQuery, sortOption, searchQuery } = props;

  const [state, setState] = useState({
    gender: 'All', maxAge: 100, minAge: 0, language: '', city: '', sortOption: sortOption || 'recentlyAdded'
  });

  const [modalState, setModalState] = useState(false)
  const [searchExpanded, setSearchExpanded] = useState(false)

  // Sync local state with Redux state when component mounts or Redux state changes
  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      sortOption: sortOption || 'recentlyAdded'
    }));
  }, [sortOption]);

  // Calculate active filter count
  const getActiveFilterCount = () => {
    let count = 0;
    if (state.gender !== 'All') count++;
    if (state.maxAge !== 100) count++;
    if (state.minAge !== 0) count++;
    if (state.language && state.language.trim() !== '') count++;
    if (state.city && state.city.trim() !== '') count++;
    return count;
  };

  const activeFilterCount = getActiveFilterCount();

  const signOut = () => {
    logoutUser(null)
  };

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  const handleAgeChange = (event, newValue) => {
    setState({
      ...state,
      minAge: newValue[0],
      maxAge: newValue[1],
    });
  };

  const handleRemoveFilter = (filterType) => {
    switch (filterType) {
      case 'gender':
        setState({ ...state, gender: 'All' });
        setGender('All');
        break;
      case 'age':
        setState({ ...state, minAge: 0, maxAge: 100 });
        setMinAge(0);
        setMaxAge(100);
        break;
      case 'language':
        setState({ ...state, language: '' });
        setLanguage('');
        break;
      case 'city':
        setState({ ...state, city: '' });
        setCity('');
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    // Update Redux state with filter values
    // The selector will automatically compute filtered profiles
    setGender(state.gender);
    setMaxAge(state.maxAge);
    setMinAge(state.minAge);
    setLanguage(state.language);
    setCity(state.city);
    setSortOption(state.sortOption);

    toggleModal(e)
    // Prevent Refresh
    e.preventDefault()
  }

  const toggleModal = (event) => {
    setModalState(!modalState)
    event.preventDefault()
  };

  const handleReset = (event) => {
    // Reset filters in Redux
    setGender('All');
    setMaxAge(100);
    setMinAge(0);
    setLanguage('');
    setCity('');
    setSortOption('recentlyAdded');
    
    // Reset local state
    setState({
      gender: 'All', maxAge: 100, minAge: 0, language: '', city: '', sortOption: 'recentlyAdded'
    })
    toggleModal(event)
    event.preventDefault()
  }

  return (
    <Disclosure as="nav" className="bg-gray-800 sticky top-0 z-50 shadow-lg border-b border-gray-700">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 
                focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <img
                    className="h-8 w-auto"
                    // src="https://tailwindui.com/img/logos/workflow-mark-indigo-500.svg"
                    src="assets/images/Om.png"
                    alt="Om symbol - Shree Kahan Parivar Matrimony logo"
                  />
                  <div className="hidden md:block ml-6 font-semibold text-white text-lg tracking-tight flex-wrap">
                    Shree Kahan Parivar Matrimony
                  </div>
                </div>
                {
                  user && user.role === "Admin" &&
                  <div className="hidden sm:block sm:ml-6">
                    <div className="flex space-x-4">
                      {navigation.map((item) => (
                        <div className="text-gray-300 hover:bg-gray-900 hover:text-white
                                px-3 py-2 rounded-md text-sm font-medium">
                          <NavLink to={`${item.href}`}>
                            {item.name}
                          </NavLink>
                        </div>
                      ))}
                    </div>
                  </div>
                }
              </div>
              {
                  user &&
                  <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                    {/* Search Icon/Bar - Visible on all screen sizes */}
                    <div className="flex items-center mr-3">
                      {searchExpanded ? (
                        <div className="relative flex items-center">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                          </div>
                          <input
                            type="text"
                            value={searchQuery || ''}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search by name, city, education..."
                            onBlur={() => {
                              // Keep search open if there's text, close if empty
                              if (!searchQuery) {
                                setTimeout(() => setSearchExpanded(false), 200);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Escape') {
                                setSearchExpanded(false);
                                setSearchQuery('');
                              }
                            }}
                            autoFocus
                            className="
                              block w-48 sm:w-64 pl-10 pr-8 py-2
                              border border-gray-600 rounded-md
                              bg-gray-700 text-white
                              placeholder-gray-400
                              text-sm
                              focus:outline-none focus:ring-2 focus:ring-white focus:border-transparent
                              transition-all duration-200
                            "
                            aria-label="Search profiles"
                          />
                          {searchQuery && (
                            <button
                              onClick={() => setSearchQuery('')}
                              className="absolute inset-y-0 right-0 pr-2 flex items-center text-gray-400 hover:text-white"
                              aria-label="Clear search"
                            >
                              <XIcon className="h-4 w-4" aria-hidden="true" />
                            </button>
                          )}
                        </div>
                      ) : (
                        <button
                          type="button"
                          onClick={() => setSearchExpanded(true)}
                          className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none 
                          focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                          aria-label="Open search"
                        >
                          <span className="sr-only">Open search</span>
                          <SearchIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                      )}
                    </div>
                    <button
                      type="button"
                      className="bg-gray-800 p-1 rounded-full text-gray-400 hover:text-white focus:outline-none 
                      focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white relative"
                      onClick={toggleModal}
                      aria-label="Open filter menu"
                      aria-expanded={modalState}
                    >
                      <span className="sr-only">Open filter menu</span>
                      <FilterIcon className="h-6 w-6" aria-hidden="true" />
                      {activeFilterCount > 0 && (
                        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                          {activeFilterCount}
                        </span>
                      )}
                    </button>
                    <button
                      type="button"
                      className="bg-gray-800 p-1 rounded-full ml-3 text-gray-400 hover:text-white focus:outline-none 
                      focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                      onClick={signOut}
                      aria-label="Sign out"
                    >
                      <span className="sr-only">Sign out</span>
                      <LogoutIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
              }
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            {user && (
              <div className="px-2 pt-2 pb-3 space-y-1">
                <Disclosure.Button
                  key="home"
                  as="a"
                  href="#"
                  className='text-gray-300 hover:bg-gray-700 hover:text-white
                  block px-3 py-2 rounded-md text-base font-medium'
                >
                  <NavLink to="/home">
                    Home
                  </NavLink>
                </Disclosure.Button>

                {user.role === "Admin" && (
                  <Disclosure.Button
                    key="admin"
                    as="a"
                    href="#"
                    className='text-gray-300 hover:bg-gray-700 hover:text-white
                    block px-3 py-2 rounded-md text-base font-medium'
                  >
                    <NavLink to="/admin">
                      Admin
                    </NavLink>
                  </Disclosure.Button>
                )}
              </div>
            )}
          </Disclosure.Panel>

          <Modal
            open={modalState}
            onClose={toggleModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            closeAfterTransition
          >
            <Box sx={style}>
              <form noValidate onSubmit={handleSubmit}>
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <FilterIcon className="h-6 w-6 text-indigo-600" aria-hidden="true" />
                    <Typography id="modal-modal-title" variant="h6" component="h2" className="font-semibold">
                      Filters & Sort
                    </Typography>
                    {activeFilterCount > 0 && (
                      <span className="ml-2 px-2 py-0.5 bg-indigo-100 text-indigo-700 text-xs font-semibold rounded-full">
                        {activeFilterCount} active
                      </span>
                    )}
                  </div>
                </div>

                {/* Active Filter Chips */}
                {activeFilterCount > 0 && (
                  <div className="mb-4 flex flex-wrap gap-2">
                    {state.gender !== 'All' && (
                      <Chip
                        icon={<UserIcon className="h-4 w-4" />}
                        label={`Gender: ${state.gender}`}
                        onDelete={() => handleRemoveFilter('gender')}
                        color="primary"
                        size="small"
                        variant="outlined"
                      />
                    )}
                    {(state.minAge !== 0 || state.maxAge !== 100) && (
                      <Chip
                        icon={<CalendarIcon className="h-4 w-4" />}
                        label={`Age: ${state.minAge}-${state.maxAge}`}
                        onDelete={() => handleRemoveFilter('age')}
                        color="primary"
                        size="small"
                        variant="outlined"
                      />
                    )}
                    {state.language && state.language.trim() !== '' && (
                      <Chip
                        icon={<GlobeAltIcon className="h-4 w-4" />}
                        label={`Language: ${state.language}`}
                        onDelete={() => handleRemoveFilter('language')}
                        color="primary"
                        size="small"
                        variant="outlined"
                      />
                    )}
                    {state.city && state.city.trim() !== '' && (
                      <Chip
                        icon={<LocationMarkerIcon className="h-4 w-4" />}
                        label={`City: ${state.city}`}
                        onDelete={() => handleRemoveFilter('city')}
                        color="primary"
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </div>
                )}

                {/* Filter Presets */}
                <div className="mb-4">
                  <Typography variant="subtitle2" className="font-semibold text-gray-700 mb-2">
                    Quick Filters
                </Typography>
                  <div className="flex flex-wrap gap-2">
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        setState({
                          ...state,
                          minAge: 25,
                          maxAge: 30,
                          gender: 'All'
                        });
                      }}
                      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                    >
                      Age 25-30
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        setState({
                          ...state,
                          minAge: 30,
                          maxAge: 35,
                          gender: 'All'
                        });
                      }}
                      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                    >
                      Age 30-35
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        setState({
                          ...state,
                          minAge: 0,
                          maxAge: 100,
                          gender: 'Male'
                        });
                      }}
                      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                    >
                      Male Only
                    </Button>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        setState({
                          ...state,
                          minAge: 0,
                          maxAge: 100,
                          gender: 'Female'
                        });
                      }}
                      sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                    >
                      Female Only
                    </Button>
                  </div>
                </div>

                <Divider sx={{ my: 2 }} />

                {/* Gender Filter Section */}
                <div className="mb-4">
                  <div className="flex items-center gap-2 mb-2">
                    <UserIcon className="h-5 w-5 text-indigo-600" aria-hidden="true" />
                    <Typography variant="subtitle2" className="font-semibold text-gray-700">
                      Gender
                </Typography>
                  </div>
                <TextField
                  variant="outlined"
                  fullWidth
                    id="gender"
                  select
                  label="Select Gender"
                  name="gender"
                  value={state.gender}
                  onChange={handleChange}
                  size="small"
                    sx={{ mt: 1 }}
                  aria-label="Select gender filter"
                >
                  {genderList.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                </div>

                <Divider sx={{ my: 2 }} />

                {/* Age Filter Section */}
                <div className="mb-4">
                  <div className="flex items-center gap-2 mb-3">
                    <CalendarIcon className="h-5 w-5 text-indigo-600" aria-hidden="true" />
                    <Typography variant="subtitle2" className="font-semibold text-gray-700">
                      Age Range
                    </Typography>
                  </div>
                  <div className="px-2">
                    <Slider
                      value={[state.minAge, state.maxAge]}
                      onChange={handleAgeChange}
                      valueLabelDisplay="auto"
                      min={18}
                      max={100}
                      step={1}
                      marks={[
                        { value: 18, label: '18' },
                        { value: 30, label: '30' },
                        { value: 50, label: '50' },
                        { value: 70, label: '70' },
                        { value: 100, label: '100' }
                      ]}
                      sx={{ mt: 2 }}
                      aria-labelledby="age-range-slider"
                    />
                    <div className="flex justify-between text-xs text-gray-500 mt-1">
                      <span>Min: {state.minAge} years</span>
                      <span>Max: {state.maxAge} years</span>
                    </div>
                  </div>
                </div>

                <Divider sx={{ my: 2 }} />

                {/* Location & Language Section */}
                <div className="mb-4">
                  <div className="flex items-center gap-2 mb-3">
                    <LocationMarkerIcon className="h-5 w-5 text-indigo-600" aria-hidden="true" />
                    <Typography variant="subtitle2" className="font-semibold text-gray-700">
                      Location & Language
                    </Typography>
                  </div>
                <TextField
                    id="city"
                    label="City"
                    type="search"
                  size="small"
                    name="city"
                    value={state.city}
                  onChange={handleChange}
                    fullWidth
                    sx={{ mb: 2 }}
                    aria-label="City filter"
                />
                <TextField
                  id="language"
                  label="Language"
                  type="search"
                  size="small"
                  name="language"
                  value={state.language}
                  onChange={handleChange}
                    fullWidth
                  aria-label="Language filter"
                />
                </div>

                <Divider sx={{ my: 2 }} />

                {/* Sort Section */}
                <div className="mb-4">
                  <div className="flex items-center gap-2 mb-2">
                    <SortAscendingIcon className="h-5 w-5 text-indigo-600" aria-hidden="true" />
                    <Typography variant="subtitle2" className="font-semibold text-gray-700">
                      Sort By
                    </Typography>
                  </div>
                <TextField
                    variant="outlined"
                    fullWidth
                    id="sort-option"
                    select
                    label="Sort Order"
                    name="sortOption"
                    value={state.sortOption}
                    onChange={handleChange}
                  size="small"
                    sx={{ mt: 1 }}
                    aria-label="Sort profiles"
                  >
                    <MenuItem value="recentlyAdded">Recently Added</MenuItem>
                    <MenuItem value="ageAsc">Age: Low to High</MenuItem>
                    <MenuItem value="ageDesc">Age: High to Low</MenuItem>
                    <MenuItem value="nameAsc">Name: A to Z</MenuItem>
                  </TextField>
                </div>

                <Divider sx={{ my: 3 }} />

                {/* Action Buttons */}
                <div className="flex gap-2 justify-end">
                  <Button 
                    variant="outlined" 
                    color="secondary"
                    onClick={handleReset}
                    aria-label="Reset all filters"
                    sx={{ 
                      minWidth: 100,
                      textTransform: 'none',
                      fontWeight: 600
                    }}
                  >
                    Reset
                  </Button>
                  <Button 
                    type="submit" 
                    variant="contained" 
                    color="primary"
                    aria-label="Apply filters"
                    sx={{ 
                      minWidth: 100,
                      textTransform: 'none',
                      fontWeight: 600,
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      '&:hover': {
                        background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
                      }
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </form>
            </Box>
          </Modal>
        </>
      )}
    </Disclosure>
  )
}

const mapStateToProps = state => ({
  user: state.user,
  sortOption: state.sortOption || 'recentlyAdded',
  searchQuery: state.searchQuery || ''
});

const mapDispatchToProps = dispatch => ({
  logoutUser: user => dispatch(logoutUser(user)),
  setGender: gender => dispatch(setGender(gender)),
  setLanguage: language => dispatch(setLanguage(language)),
  setMaxAge: age => dispatch(setMaxAge(age)),
  setMinAge: age => dispatch(setMinAge(age)),
  setCity: city => dispatch(setCity(city)),
  setSortOption: option => dispatch(setSortOption(option)),
  setSearchQuery: query => dispatch(setSearchQuery(query))
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
